import { render, staticRenderFns } from "./ReferralEvaluationRow.vue?vue&type=template&id=54ad0f25&scoped=true"
import script from "./ReferralEvaluationRow.vue?vue&type=script&lang=js"
export * from "./ReferralEvaluationRow.vue?vue&type=script&lang=js"
import style0 from "./ReferralEvaluationRow.vue?vue&type=style&index=0&id=54ad0f25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad0f25",
  null
  
)

export default component.exports